module.exports = __webpack_public_path__ + "img/arrowRightPromo.718ebc46.svg";